export const initialState = {
  mag: {
    loading: false,
    articles: [],
    article: null
  }
};
